/**
 * Module-level workspace state.
 * Services import this to get the current workspace_id without needing React context.
 * WorkspaceContext sets this on resolution.
 */

const STORAGE_KEY = 'wf_current_workspace_id';

function readStoredWorkspaceId(): string {
  if (typeof window === 'undefined') return 'default';
  return window.localStorage.getItem(STORAGE_KEY) || 'default';
}

let _currentWorkspaceId = readStoredWorkspaceId();

export function setCurrentWorkspaceId(id: string) {
  _currentWorkspaceId = id || 'default';

  if (typeof window !== 'undefined') {
    if (_currentWorkspaceId === 'default') {
      window.localStorage.removeItem(STORAGE_KEY);
    } else {
      window.localStorage.setItem(STORAGE_KEY, _currentWorkspaceId);
    }
  }
}

export function clearCurrentWorkspaceId() {
  _currentWorkspaceId = 'default';
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(STORAGE_KEY);
  }
}

export function getCurrentWorkspaceId(): string {
  return _currentWorkspaceId;
}
